import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  standalone: false,
  selector: "o-loading-modal",
  templateUrl: "./loading-modal.component.html",
  styleUrls: ["./loading-modal.component.scss"]
})
export class LoadingModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: string) {}
}
